document.addEventListener("DOMContentLoaded", function() { 
  // set external links to open in new tab
  // append to external links only
  jQuery.expr[':'].external = function(obj){
    return !obj.href.match(/^mailto:/)
    && (obj.hostname != location.hostname)
    && !obj.href.match(/^javascript:/)
    && !obj.href.match(/^$/)
    && !obj.href.match(/^tel:/)
  };
  jQuery('a:external').attr('target', '_blank');


  jQuery('.is-style-button-group').find('.wp-block-button__link').each(function(i,e) {
    var text = e.innerHTML.split('<br>')
    e.innerHTML = `${text[0]}<span>${text[1]}</span>`;
  });
});